import React from 'react';
import { FadeIn } from './FadeIn';
export const FailedAttemptsSection = () => {
  const attempts = ['Los suplementos energéticos que probaste eran genéricos y no diseñados para tu rutina.', 'Saltarte el desayuno solo empeoró tus bajones de energía a media mañana.', 'Los batidos que intentaste no tenían el balance correcto entre proteínas, grasas saludables y carbohidratos.'];
  return <section className="py-20 bg-darker" data-id="element-30">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-31">
        <FadeIn data-id="element-32">
          <h2 className="font-serif text-3xl md:text-4xl font-bold mb-12 text-center text-white" data-id="element-33">
            ¿Por Qué Lo Que Has Probado{' '}
            <span className="text-red-400" data-id="element-34">No Funciona?</span>
          </h2>
        </FadeIn>
        <div className="space-y-6" data-id="element-35">
          {attempts.map((attempt, index) => <FadeIn key={index} delay={0.2 + index * 0.1} data-id="element-36">
              <div className="flex items-start bg-dark p-6 rounded-xl border border-gray-800" data-id="element-37">
                <span className="text-2xl mr-4 flex-shrink-0" data-id="element-38">❌</span>
                <p className="text-lg text-gray-300" data-id="element-39">{attempt}</p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
};